import {Fragment} from "react";
import {User} from "../../../../services/UsersService";

interface UserCountersTabProps {
  readonly user: User;
}

const UserCountersTab = (props: UserCountersTabProps) => {
  const {user} = props;

  return (
    <Fragment>
      <div className="form-group">
        <label htmlFor="cachedNumCached" className="form-label">
          cached num cached
        </label>
        <input type="number" className="form-control" id="cachedNumCached" defaultValue={user.cachedNumCached} disabled readOnly />
      </div>

      <div className="form-group">
        <label htmlFor="cachedRenderCounter" className="form-label">
          cached render counter
        </label>
        <input type="number" className="form-control" id="cachedRenderCounter" defaultValue={user.cachedRenderCounter} disabled readOnly />
      </div>

      <div className="form-group">
        <label htmlFor="allUrlCount" className="form-label">
          all url count
        </label>
        <input type="number" className="form-control" id="cachedAllUrlCount" defaultValue={user.cachedAllUrlCount} disabled readOnly />
      </div>

      <div className="form-group">
        <button className="btn btn-primary" type="button" data-toggle="collapse" data-target="#collapseExample">
          DB values
        </button>
      </div>

      <div className="collapse" id="collapseExample">
        <div className="form-group">
          <label htmlFor="numCached" className="form-label">
            num cached
          </label>
          <input type="number" className="form-control" id="numCached" defaultValue={user.numCached} disabled readOnly />
        </div>

        <div className="row align-items-center">
          <div className="col">
            <div className="form-group">
              <label htmlFor="renderCounter" className="form-label">
                render counter
              </label>
              <input type="number" className="form-control" id="renderCounter" value={user.renderCounter} disabled readOnly />
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="form-group">
            <label htmlFor="allUrlCount" className="form-label">
              all url count
            </label>
            <input type="number" className="form-control" id="allUrlCount" defaultValue={user.allUrlCount} disabled readOnly />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserCountersTab;
